import React from 'react';
export default class MarketplaceBar extends React.Component {
    render() {
        let url = `https://www.aperza.com/corp/contact/aperza`;
        return (React.createElement("div", { className: "marketplace-bar" },
            React.createElement("img", { className: "marketplace-bar-img", useMap: "#marketplacemap", src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" }),
            React.createElement("map", { name: "marketplacemap" },
                React.createElement("area", { shape: "rect", coords: "914,16,962,30", href: url, target: "_blank" }))));
    }
}
